import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Banner from "../../Components/Banner";
import useSWR from "swr";
import { URLS } from "../../Services/urls";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Section from "../../Components/Section";
import ProductWrapper from "../../Components/Product/ProductWrapper";
import Nested from "../../Components/Nested";
import Input from "../../Components/Input";
import StepTitle from "../../Components/Title";
import ButtonNav from "../../Components/ButtonNav";
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa"; 
import SectionImage from "../../Components/SectionImage";
import ChoiceItem from "../../Components/ChoiceItem";
import { setProjectType, setSectionNames } from "../../Redux/Slice/selectedProductsSlice";
import { useSelector } from "react-redux";
import NestedProductWrapper from "../../Components/Product/NestedProductWrapper";

const Project = () => {
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: project, isLoading } = useSWR(URLS.PROJECT.details(projectId))
  
  // Récupérer les données Redux pour debug
  const selectedProducts = useSelector(state => state.selectedProducts.selectedProducts);
  const userInputs = useSelector(state => state.selectedProducts.userInputs);
  const sectionNames = useSelector(state => state.selectedProducts.sectionNames);
  
  // Debug: Afficher l'état Redux
  useEffect(() => {
    console.log('🔍 Project - selectedProducts:', selectedProducts);
    console.log('🔍 Project - userInputs:', userInputs);
  }, [selectedProducts, userInputs]);

  // Debug: Afficher la structure des données du projet
  useEffect(() => {
    if (project) {
      console.log("Structure du projet:", project);
      console.log("Steps du projet:", project.steps);
      if (project.steps && project.steps[0]) {
        console.log("Sections de la première étape:", project.steps[0].sections);
        if (project.steps[0].sections && project.steps[0].sections[0]) {
          console.log("Produits de la première section:", project.steps[0].sections[0].products);
        }
      }
      
      // Initialiser le type de projet pour les calculs
      if (project.project_type) {
        dispatch(setProjectType(project.project_type));
        console.log("Type de projet initialisé:", project.project_type);
      }
      
      // Sauvegarder les noms de sections
      const sectionNames = {};
      if (project.steps) {
        project.steps.forEach(step => {
          if (step.sections) {
            step.sections.forEach(section => {
              sectionNames[section.id] = section.name;
            });
          }
        });
        dispatch(setSectionNames(sectionNames));
        console.log("Noms de sections sauvegardés:", sectionNames);
      }
    }
  }, [project, dispatch]);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedNestedSection, setSelectedNestedSection] = useState(null);

  const handleChangeStep = (stepIndex) => {
    setActiveStep(stepIndex);
    // Réinitialiser la sélection de nested section lors du changement d'étape
    setSelectedNestedSection(null);
  };

  const handleNestedSectionClick = (nestedSection) => {
    // Si la même nested section est cliquée, la désélectionner
    if (selectedNestedSection?.id === nestedSection.id) {
      setSelectedNestedSection(null);
    } else {
      // Sinon, sélectionner la nouvelle nested section
      setSelectedNestedSection(nestedSection);
    }
  };

  const handlePrevStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleNextStep = () => {
    console.log('🔍 handleNextStep appelé:', {
      activeStep,
      totalSteps: project?.steps?.length,
      isLastStep: activeStep >= (project?.steps?.length - 1)
    });
    
    if (activeStep < project.steps.length - 1) {
      setActiveStep(activeStep + 1);
    } else {
      // Si on est à la dernière étape, rediriger vers la finalisation
      console.log('🚀 Redirection vers /finalization');
      console.log('🔍 URL actuelle avant redirection:', window.location.href);
      
      // Utiliser directement window.location.href pour forcer la navigation
      window.location.href = '/finalization';
    }
  };

  const toUpper = (sectionName) => {
    return sectionName.toUpperCase();
  };

  useEffect(() => {
    if (project && activeStep === null) {
      setActiveStep(0);
    }
  }, [project]);

  // Sauvegarder les noms de sections des nested sections dans Redux
  useEffect(() => {
    if (selectedNestedSection && selectedNestedSection.sections) {
      const newSectionNames = { ...sectionNames };
      selectedNestedSection.sections.forEach(nestedSectionItem => {
        if (nestedSectionItem.id && nestedSectionItem.name) {
          newSectionNames[nestedSectionItem.id] = nestedSectionItem.name;
        }
      });
      if (Object.keys(newSectionNames).length > Object.keys(sectionNames).length) {
        dispatch(setSectionNames(newSectionNames));
      }
    }
  }, [selectedNestedSection, sectionNames, dispatch]);


  return (
    <>
      <div>
        {
          isLoading && <p className="text-center">Chargement...</p>
        }
      </div> 
      <Banner projectName={String(project?.name).replace('_', ' ')} />
      <section className="page-banner">
        <div className="container">
          <div className="d-flex">
            <div className="m-auto">
              {/* <h3 class="page-title">BOIS DE CONSTRUCTION</h3> */}
              <div className="breadcrumbss">
                {
                  project?.steps?.map((step, index) => (
                    <Link to="#" key={step.id} onClick={() => handleChangeStep(index)}>
                      <div className={`breadcrumb-item ${activeStep === index ? 'active' : activeStep > index ? 'passed' : ''}`}>{step.name}</div>
                    </Link>     
                  ))
                }
                <Link to="/finalization">
                  <div className="breadcrumb-item">Finalisation</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* List sections */}
      <section className="container">
          {
            project?.steps?.map((step, index) => {

              return(
                <div key={`stepList-${step.id || index}`} className={`steps-list ${activeStep === index ? 'd-block' : 'd-none'}`}>
                  
                  <StepTitle
                    title={step.description}
                  />
                  
                  {step?.sections?.map((section) => {
                    // Debug: Afficher la structure des sections
                    console.log('🔍 Section:', section.name, 'Inputs:', section.inputs);
                    
                    // Vérifier si cette section a une nested_section sélectionnée
                    const hasSelectedNested = selectedNestedSection && 
                      section?.nested_sections?.some(ns => ns.id === selectedNestedSection.id);
                    
                    // Récupérer les sections de la nested_section sélectionnée si elle appartient à cette section
                    // Trier par order si disponible
                    const nestedSectionsToDisplay = hasSelectedNested && selectedNestedSection.sections 
                      ? [...selectedNestedSection.sections].sort((a, b) => (a.order || 0) - (b.order || 0))
                      : [];
                    
                    return(
                      <React.Fragment key={section.id}>
                        <Section
                          name={toUpper(section.name)}
                          description={section.description}
                          classe={section?.nested_sections?.length > 0 ? 'px-5' : section?.name === 'Taille de votre terrasse' ? 'px-5' : ''}
                          textClass={section?.nested_sections?.length > 0 ? 'text' : section?.name === 'Taille de votre terrasse' ? 'text' : 'text-2'}
                          sectionClass={section.name && 'bois-de-pays'}
                          content={
                            <>
                              {
                                section?.choice_items?.length > 0 && (
                                  section.choice_items.map(choice => (
                                    <ChoiceItem
                                      key={choice.id}
                                      choice={choice}
                                      sectionId={section.id}
                                    />
                                  ))
                                )
                              }

                              {
                                section?.products?.length > 0 && (
                                  section?.products?.map((product) => (
                                      <ProductWrapper
                                        key={product.id}
                                        productId={product.product}
                                        productType={product.product_type}
                                        section={section.id}
                                        contentProductId={product.id}
                                      />
                                  ))
                                )
                              }

                              {
                                section?.nested_sections?.length > 0 && (
                                  section?.nested_sections?.map((nestedSection) => (
                                    <Nested
                                      key={nestedSection.id}
                                      label={nestedSection.name.toUpperCase()}
                                      alt={nestedSection.name}
                                      imageUrl={nestedSection.image || '/assets/images/Beton-plot.png'}
                                      nestedSection={nestedSection}
                                      isSelected={selectedNestedSection?.id === nestedSection.id}
                                      onNestedClick={handleNestedSectionClick}
                                    />
                                  ))
                                )
                              }

                              {
                                section?.inputs && Array.isArray(section.inputs) && section.inputs.length > 0 && (
                                  section.inputs.map((input) => (
                                    <Input
                                      key={input.id}
                                      label={input.input_label}
                                      info={input.input_info}
                                      description={input.description}
                                      unity={input.input_unity}
                                      type={input.input_type}
                                      section={section.id}
                                      inputKey={input.input_label || 'input'}
                                    />
                                  ))
                                )
                              }

                              {
                                section?.images?.length > 0 && (
                                  section?.images?.map((image) => (
                                    <SectionImage
                                      key={image.id}
                                      src={image.file}
                                    />
                                  ))
                                )
                              }
                            </>
                          }
                        />
                        
                        {/* Afficher les sections de la nested_section sélectionnée */}
                        {hasSelectedNested && nestedSectionsToDisplay.length > 0 && (
                          <div className="mt-4 mb-4" style={{ marginLeft: '2rem', borderLeft: '3px solid #B39C81', paddingLeft: '1rem' }}>
                            {nestedSectionsToDisplay.map((nestedSectionItem) => {
                              return (
                                <Section
                                  key={nestedSectionItem.id}
                                  name={toUpper(nestedSectionItem.name || selectedNestedSection.name)}
                                  description={nestedSectionItem.description || selectedNestedSection.description}
                                  classe="px-5"
                                  textClass="text"
                                  sectionClass="bois-de-pays"
                                  content={
                                    <>
                                      {
                                        nestedSectionItem?.choice_items?.length > 0 && (
                                          nestedSectionItem.choice_items.map(choice => (
                                            <ChoiceItem
                                              key={choice.id}
                                              choice={choice}
                                              sectionId={nestedSectionItem.id}
                                            />
                                          ))
                                        )
                                      }

                                      {
                                        nestedSectionItem?.products?.length > 0 && (
                                          nestedSectionItem.products.map((product) => (
                                            <NestedProductWrapper
                                              key={product.id}
                                              productId={product.product}
                                              productType={product.product_type}
                                              section={nestedSectionItem.id}
                                              contentProductId={product.id}
                                            />
                                          ))
                                        )
                                      }

                                      {
                                        nestedSectionItem?.images?.length > 0 && (
                                          nestedSectionItem.images.map((image) => (
                                            <SectionImage
                                              key={image.id}
                                              src={image.file}
                                            />
                                          ))
                                        )
                                      }

                                      {
                                        nestedSectionItem?.inputs && Array.isArray(nestedSectionItem.inputs) && nestedSectionItem.inputs.length > 0 && (
                                          nestedSectionItem.inputs.map((input) => (
                                            <Input
                                              key={input.id}
                                              label={input.input_label}
                                              info={input.input_info}
                                              description={input.description}
                                              unity={input.input_unity}
                                              type={input.input_type}
                                              section={nestedSectionItem.id}
                                              inputKey={input.input_label || 'input'}
                                            />
                                          ))
                                        )
                                      }
                                    </>
                                  }
                                />
                              );
                            })}
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })}
                </div>
              )
            })
          }
      </section>
      
      <div className="m-auto">
        <div className="d-flex justify-content-center mb-5">
          <div className="bois-de-pays px-3 me-2">
            <span className="text-2 span">
              <Link to="#" className='d-flex  align-items-center' onClick={handlePrevStep}>
                <FaLongArrowAltLeft className='me-2' />  MODIFIEZ
              </Link>
            </span>
          </div>
          <div className="btn btn-secondary px-3 rounded-0 d-flex align-items-center">
            <span className="text-2 " >
              <Link to="#" className="d-flex align-items-center " onClick={handleNextStep}>
                SUIVANT  <FaLongArrowAltRight  className='ms-2'/>
              </Link>
            </span>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Project;
